import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RegisterValidation, UserRegistration, LoginValidation, UserLogin } from '../Data';
import { toast } from 'react-toastify';
import Util from '../../Classes/Utils';
import Cookies from "js-cookie";

const AuthenticationAR = (props) => {
  const [phonenumber, setPhonenumber] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const navigate = useNavigate();

  const handleRegister = (e) => {
    e.preventDefault();
    if (RegisterValidation(email, password, firstName, lastName, confirmPassword)) {
      UserRegistration(email, password, firstName, lastName).then((result) => {
        toast.success("تم تسجيل العميل بنجاح");
        localStorage.setItem("Number", Util.encrypt(result.CustomerId));
        localStorage.setItem("User", Util.encrypt(email));
        navigate("/AR/Email-Confirmation")
      }).catch((error) => {
        toast.error(error.message.replaceAll('"', ""));
      });
    }
  }


  const handleLogin = (e) => {
    e.preventDefault();
    if (LoginValidation(email, password)) {
      UserLogin(email, password).then((Result) => {
        toast.success("تم تسجيل الدخول بنجاح");
      
        // localStorage.setItem("User", Util.encrypt(email));
        // localStorage.setItem("PMToken", Util.encrypt(Result.CustomerToken));
        // localStorage.setItem("Number", Util.encrypt(Result.CustomerId));
        // localStorage.setItem("WishList", Util.encrypt(Result.WishlistId));
        // localStorage.setItem("Cart", Util.encrypt(Result.CartId));
        // localStorage.setItem(
        //   "Subscribe",
        //   Util.encrypt(Result.IsSubscribed)
        // );
        props.setSubscribe(Result.IsSubscribed);
        window.location.href = "/AR/Account";
        Cookies.set('User', email, {
					expires: 5
				  });
				  Cookies.set('WishList', Result.WishlistId, {
					expires: 5
				  });
				  Cookies.set('Cart', Result.CartId, {
					expires: 5
				  });
				  Cookies.set('Subscribe', Result.IsSubscribed, {
					expires: 5
				  });
				  Cookies.set('Number', Result.CustomerId, {
					expires: 5
				  });
				  Cookies.set('CustomerToken', Result.Token, {
					expires: 5
				  });
      })
        .catch((error) => {
          if (
            error.message.replaceAll('"', "") === "Please Confirm Your Email"

          ) {
            localStorage.setItem("User", Util.encrypt(email));

            navigate("/AR/Email-Confirmation")
          } else if (error.message.replaceAll('"', "") === "Please Reset Your Password") {
            navigate("/AR/Reset-Password")
          }

          toast.error(error.message.replaceAll('"', ""));
        });
    }

  }
  return (
    <>
      <div className="breadcrumb-area mb-5 ">
        <div className="container ">
          <div className="row ">
            <div className="col ">
              <div className="breadcrumb-container  d-flex flex-row-reverse   ">
                <div className="breadcrumbArabic HomeShop">
                  <ul>
                    <li className="active">تسجيل الدخول-حساب جديد</li>
                    <li><a style={{ direction: 'rtl' }} href="/"><i className="fa fa-home"></i>
                      المنزل</a></li>

                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content mb-5">
        <div className="container">
          <div className="row directionRtl">
            <div className="col-sm-12 col-md-12 col-xs-12 col-lg-6 mb-3">
              <form onSubmit={handleLogin}>

                <div className="login-form">
                  <h4 className="login-title">تسجيل الدخول</h4>

                  <div className="row">
                    <div className="col-md-12 col-12 mb-2">
                      <label>*البريد الإلكتروني</label>
                      <input className="mb-0" type="email" placeholder="البريد الإلكتروني" required onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className="col-12 mb-2 mt-2">
                      <label>كلمة المرور</label>
                      <input className="mb-0" type="password" placeholder="كلمة المرور" required onChange={(e) => setPassword(e.target.value)} />
                    </div>
                    {/* <div className="col-md-8">

                                    <div className="check-box d-inline-block ml-0 ml-md-2 mt-1">
                                        <input type="checkbox" id="remember_me" />
                                        <label for="remember_me">حفظ كلمة المرور</label>
                                    </div>

                                </div> */}

                    <div className="col-md-4 mt-10 mb-2 text-start text-md-end">
                      <a href="/AR/Forget-Password"> هل نسيت كلمة السر؟</a>
                    </div>

                    <div className="col-md-12">
                      <button type='submit' className="register-button mt-0 RemUnderline">تسجيل الدخول</button>
                    </div>

                  </div>
                </div>

              </form>
            </div>
            <div className="col-sm-12 col-md-12 col-xs-12 col-lg-6">
              <form onSubmit={handleRegister}>

                <div className="login-form">
                  <h4 className="login-title RemUnderline">حساب جديد</h4>

                  <div className="row">
                    <div className="col-md-6 col-12 mb-2 mt-2">
                      <label>الإسم الأول</label>
                      <input className="mb-0" type="text" placeholder="الإسم الأول" required onChange={(e) => setFirstName(e.target.value)} />
                    </div>
                    <div className="col-md-6 col-12 mb-2 mt-2">
                      <label>إسم العائلة</label>
                      <input className="mb-0" type="text" placeholder="إسم العائلة" required onChange={(e) => setLastName(e.target.value)} />
                    </div>
                    <div className="col-md-12 mb-2 mt-2">
                      <label>*البريد الإلكتروني</label>
                      <input className="mb-0" type="email" placeholder="البريد الإلكتروني" required onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className="col-md-6 mb-20 mt-2">
                      <label>رقم الهاتف</label>
                      <input className="mb-0" type="text" placeholder="رقم الهاتف" required onChange={(e) => setPhonenumber(e.target.value)} />
                    </div>
                    <div className="col-md-6 mb-2 mt-2">
                      <label>كلمة المرور</label>
                      <input className="mb-0" type="password" placeholder="كلمة المرور" required onChange={(e) => setPassword(e.target.value)} />
                    </div>
                    <div className="col-md-6 mb-2 mt-2">
                      <label>تأكيد كلمة المرور</label>
                      <input className="mb-0" type="password" placeholder="تأكيد كلمة المرور" required onChange={(e) => setConfirmPassword(e.target.value)}/>
                    </div>
                    <div className="col-12 mt-3">
                      <button className="register-button mt-0 RemUnderline">حساب جديد</button>
                    </div>
                  </div>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>


    </>
  )
}

export default AuthenticationAR